import React from 'react';
import PropTypes from 'prop-types';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { gaWrapper } from 'helpers/analytics';
import s from './OpenInAppBtn.scss';

class OpenInAppBtn extends React.PureComponent {
  componentDidMount() {
    const cat = this.props.gaCategory || `OpenAppHeader`;
    const action = this.props.gaViewAction || `Open`;
    if (cat !== 'mWEB-articleshowv2' || action !== 'OpenApp_button_Seen') {
      gaWrapper('send', 'event', cat, action, window.location.href, {
        nonInteraction: 1,
      });
    }
  }
  render() {
    const openappLink =
      this.props.openappUrl ||
      'https://timesofindia.onelink.me/efRt/GetAppUSHomepage';
    return (
      <div className={s.parentContainer}>
        <a // anchor element has been used so as to not interfere with deep linking
          href={openappLink}
          title="open in TOI app"
          aria-label="open in TOI app"
          onClick={() => {
            sendGaThroughProps({
              data: {
                gaCategory: this.props.gaCategory || `NavBar-AppDownload`,
                gaAction: this.props.gaAction || `NavBar-AppDownload`,
                gaLabel: `https://timesofindia.indiatimes.com${
                  window.location.pathname
                }`,
              },
            });
          }}
        >
          <span className={`${this.props.themeClass ? s.themeClass : ''}`}>
            Open App
          </span>
        </a>
      </div>
    );
  }
}
OpenInAppBtn.propTypes = {
  themeClass: PropTypes.string,
  gaCategory: PropTypes.string,
  gaAction: PropTypes.string,
  openappUrl: PropTypes.string,
  gaViewAction: PropTypes.string,
};
OpenInAppBtn.defaultProps = {
  themeClass: '',
  gaCategory: '',
  gaAction: '',
  openappUrl: '',
  gaViewAction: '',
};

export default OpenInAppBtn;
